import React from 'react';

import FilterPlate from 'components/FilterPlates/FilterPlate';

import EmptyPinnedFilterPlate from './EmptyPinnedFilterPlate';
import { PinnedFilterSlot } from './usePinnedFilterSlots';

const PinnedFilterPlates = ({ slots }: { slots: PinnedFilterSlot[] }) => (
  <>
    {slots.map(({ pin, plate }) =>
      plate ? (
        <FilterPlate
          key={pin.id}
          plate={plate}
          isScope={false}
          isReport
          isAlwaysInteractive
        />
      ) : (
        <EmptyPinnedFilterPlate key={pin.id} pin={pin} />
      ),
    )}
  </>
);

export default PinnedFilterPlates;
